// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconSubtract = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M52 33.875C52 35.1091 51.2341 35.875 50 35.875C48.8646 35.875 41.6583 34.875 32 34.875C22.3417 34.875 15.1354 35.875 14 35.875C12.7659 35.875 12 35.1091 12 33.875V30.125C12 28.8909 12.7659 28.125 14 28.125C15.1354 28.125 22.3417 29.125 32 29.125C41.6583 29.125 48.8646 28.125 50 28.125C51.2341 28.125 52 28.8909 52 30.125V33.875Z" />
    </svg>
  );
};
